import { Box, Tag, Text, useMediaQuery } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { DEFAULT_PROPERTY_IMAGE_URL } from '~/apps/consumer/utils/listing.utils';
import { useIsMobile } from '~/common/hooks/useIsMobile';
import { ListingPhotoCarousel } from '../../ListingPhotoCarousel/ListingPhotoCarousel';

export interface ComparablePhotoProps {
  images: string[];
  status?: string;
  closeDate?: string;
}
export const ComparablePhoto = ({
  images,
  status,
  closeDate,
}: ComparablePhotoProps) => {
  const isMobile = useIsMobile();
  const [isPrint] = useMediaQuery('print');

  return (
    <Box position="relative">
      <ListingPhotoCarousel
        borderRadius="none"
        images={images?.length ? images : [DEFAULT_PROPERTY_IMAGE_URL]}
        options={{
          perPage: 1,
          breakpoints: {},
          height: isPrint ? '100px' : isMobile ? '120px' : '150px',
          width: '100%',
        }}
      />
      {status && (
        <Box left={2} position="absolute" right="60px" top={2}>
          <Tag variant="dark">
            <Text overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
              {status}
              {closeDate ? ` - ${dayjs(closeDate).format('MM/DD/YYYY')}` : ''}
            </Text>
          </Tag>
        </Box>
      )}
    </Box>
  );
};
